import { Injectable } from '@angular/core';
import { HttpService } from '@web-di-ld/apps/http';
import { AppStateService } from '../../../app-state.service';
import { CustomerDetail } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(
    private appState: AppStateService,
    private httpService: HttpService
  ) {}

  getCustomerDetail(id?: string) {
    return this.httpService
      .get<CustomerDetail>(`/api/applications/v2/customer-detail`)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
        return [];
      });
  }

  public updateCustomerDetail(customerDetail: CustomerDetail) {
    this.appState.updateStateCustomerDetail(customerDetail);
  }
}
